module.exports = __webpack_public_path__ + "img/check_but_tip.bfdaf3f0.png";